import { readonly } from 'vue'
import state from './state'
import getters from './getters'

export default {
  get state () {
    return readonly(state())
  },

  getters
}
